module.exports = __webpack_public_path__ + "background6.jpg?481f99e3ae326b9cafe86f17d490c740";